// TS mirrors of the /api/documents wire shapes (DocumentsController).

import type { ParsedExtraction } from "@/features/upload/types";
import type { PaaExtraction } from "@/features/paa/types";

// Server enum DocumentType crosses the wire as the string name.
export type DocumentType = "Objections" | "Paa";

export interface DocumentSummary {
  id: string;
  type: DocumentType;
  createdAt: string;
  updatedAt: string;
  /** Null while the run is a draft (extracted/edited but never generated). */
  generatedAt?: string | null;
  userId?: string | null;
  address?: string | null;
  jobNumber?: string | null;
  borough?: string | null;
  fileName: string;
  /** Objections: active objection count. PAA: revised sheet count. */
  itemCount: number;
  /** Objections only — resolved (excluded from the PDF). */
  resolvedCount?: number | null;
}

// The detail endpoint embeds the saved extraction payload as a JSON object;
// its shape is the same camelCase wire shape the live flows already use.
export type DocumentDetail = DocumentSummary & {
  schemaVersion: number;
  payload: ParsedExtraction | PaaExtraction;
};

export function typeSlug(type: DocumentType): "objections" | "paa" {
  return type === "Objections" ? "objections" : "paa";
}

// GET endpoints with cookie auth. Both regenerate the file server-side from the
// saved payload (so they work for drafts too); the client fetches the blob and
// shows a "Preparing…" state while it generates — see HistoryPage DownloadButton.
export function documentPdfUrl(doc: Pick<DocumentSummary, "id" | "type">): string {
  return `/api/documents/${typeSlug(doc.type)}/${doc.id}/pdf`;
}

export function documentExcelUrl(doc: Pick<DocumentSummary, "id">): string {
  return `/api/documents/objections/${doc.id}/excel`;
}
